import Vue from 'vue'
import Router from 'vue-router'
import Index from '../views/index'
import Login from '../views/login'
import Register from '../views/register'
import About from '../views/about'
import Cart from '../views/cart'
import ProductList from '../views/productList'
import ProductDetail from '../views/productDetail'
import Resource from '../views/resource'
import NewsDetail from '../views/newsDetail'
import UserIndex from '../views/user/index'
import UserCollect from '../views/user/collect'
import UserAddress from '../views/user/address'
import UserOrder from '../views/user/orders'
import ServeList from '../views/serveList'
import ServeDetail from '../views/serveDetail'
import Search from '../views/search'
import Empty from '../views/empty'
import SolutionList from '../views/solutionList'
import SolutionDetail from '../views/solutionDetail'
import TestStandard  from '../views/testStandard'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            component: Index,
            name: 'Index'
        },
        {
            path: '/Login',
            component: Login,
            name: 'Index'
        },
        {
            path: '/Register',
            component: Register,
            name: 'Register'
        },
        {
            path: '/About',
            component: About,
            name: 'About'
        },
        {
            path: '/Cart',
            component: Cart,
            name: 'Cart'
        },
        {
            path: '/ProductList',
            component: ProductList,
            name: 'ProductList'
        },
        {
            path: '/ProductDetail-:pId',
            component: ProductDetail,
            name: 'ProductDetail'
        },
        {
            path: '/Resource',
            component: Resource,
            name: 'Resource'
        },
        {
            path: '/Search-:str',
            component: Search,
            name: 'Search'
        },
        {
            path: '/NewsDetail-:nId',
            component: NewsDetail,
            name: 'NewsDetail'
        },
        {
            path: '/User',
            component: UserIndex,
            name: 'UserIndex'
        },
        {
            path: '/User/Collect',
            component: UserCollect,
            name: 'UserCollect'
        },
        {
            path: '/User/Address',
            component: UserAddress,
            name: 'UserAddress'
        },
        {
            path: '/User/Order',
            component: UserOrder,
            name: 'UserOrder'
        },
        {
            path: '/ServeList-:stId',
            component: ServeList,
            name: 'ServeList'
        },
        {
            path: '/ServeDetail-:sId',
            component: ServeDetail,
            name: 'ServeDetail'
        },
        {
            path: '/Empty-:url',
            component: Empty,
            name: 'Empty'
        },
        {
            path: '/SolutionList-:stId',
            component: SolutionList,
            name: 'SolutionList'
        },
        {
            path: '/SolutionDetail-:sId',
            component: SolutionDetail,
            name: 'SolutionDetail'
        },
        {
            path: '/TestStandard',
            component: TestStandard,
            name: 'TestStandard'
        },
    ],
    mode: 'history',//hash 或者history
    scrollBehavior() {
        return {x: 0, y: 0}
    }
})
